var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
      ],
      staticClass: "row",
      staticStyle: { "padding-top": "10px" },
    },
    [
      _c(
        "pui-form-group",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: { s: 12, m: 12, l: 12 },
              expression: "{ s: 12, m:12, l: 12 }",
            },
          ],
          staticClass: "unit_group",
          attrs: {
            label:
              _vm
                .$t("operationalData.entryView.unitReliability.title")
                .toString()
                .toUpperCase() + " :",
            "has-label-padding": false,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.breakdownEvents"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled": false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "NrBreakdownEvents")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.NrBreakdownEvents,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "NrBreakdownEvents",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.NrBreakdownEvents",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.trips"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled": false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "NrTrips")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.NrTrips,
                      callback: function ($$v) {
                        _vm.$set(_vm.activeUnitKPIModel, "NrTrips", _vm._n($$v))
                      },
                      expression: "activeUnitKPIModel.NrTrips",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.operationalHours"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      precision: 2,
                      required: _vm.required,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "OperationHours")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.OperationHours,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "OperationHours",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.OperationHours",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.totalStarts"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "Starts.Total")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.Starts.Total,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel.Starts,
                          "Total",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.Starts.Total",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.comercialStarts"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "Starts.Commercial")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.Starts.Commercial,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel.Starts,
                          "Commercial",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.Starts.Commercial",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.technicalStarts"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "Starts.Technical")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.Starts.Technical,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel.Starts,
                          "Technical",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.Starts.Technical",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.goodStarts"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      required: _vm.required,
                      min: _vm.min,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "Starts.Good")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.Starts.Good,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel.Starts,
                          "Good",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.Starts.Good",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitReliability.failedStarts"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      "is-disabled":
                        _vm.isReaderUser || _vm.activeUnitCounty === "Sweden",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "Starts.Failed")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.Starts.Failed,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel.Starts,
                          "Failed",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.Starts.Failed",
                    },
                  }),
                ],
                1
              ),
              _vm.activeUnitCounty === "Sweden"
                ? _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{ s: 12, l: 4 }",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(
                          "operationalData.entryView.unitReliability.failedStartsCommercial"
                        ),
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          min: _vm.min,
                          required: _vm.required,
                          "is-disabled": _vm.isReaderUser,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onInputChangeSweden(
                              $event,
                              "Starts.FailedCommercial"
                            )
                          },
                        },
                        model: {
                          value: _vm.activeUnitKPIModel.Starts.FailedCommercial,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.activeUnitKPIModel.Starts,
                              "FailedCommercial",
                              _vm._n($$v)
                            )
                          },
                          expression:
                            "activeUnitKPIModel.Starts.FailedCommercial",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _vm.activeUnitCounty === "Sweden"
                ? _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{ s: 12, l: 4 }",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(
                          "operationalData.entryView.unitReliability.failedStartsTechnical"
                        ),
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          min: _vm.min,
                          required: _vm.required,
                          "is-disabled": _vm.isReaderUser,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onInputChangeSweden(
                              $event,
                              "Starts.FailedTechnical"
                            )
                          },
                        },
                        model: {
                          value: _vm.activeUnitKPIModel.Starts.FailedTechnical,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.activeUnitKPIModel.Starts,
                              "FailedTechnical",
                              _vm._n($$v)
                            )
                          },
                          expression:
                            "activeUnitKPIModel.Starts.FailedTechnical",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }